import { Box } from '@coolblue-development/becky';
import { EmailContactData } from '../../../../../models/EmailContact';
import { EmailMessage } from '../../../../../models/Email';
import EmailHeaderPreview from './EmailHeaderPreview';
import EmailHeaderExpanded from './EmailHeaderExpanded';
import { formatBodyPreview } from '../../../../../utils/emailContactHelpers';

interface EmailHeaderContainerProps {
  message: EmailMessage;
  onClick?: () => void;
  isCollapsed?: boolean;
}

const EmailHeaderContainer = ({ message, onClick, isCollapsed = false }: EmailHeaderContainerProps): JSX.Element => {
  const { cc, contactId, to, bodyHtml, from, subject, timestamp, attachments, hasRejectedAttachments } = message;

  const data: EmailContactData = {
    contactId,
    customerName: from?.displayName,
    subject,
    from: from?.emailAddress,
    to: to?.map(a => (a.displayName ? `${a.displayName} <${a.emailAddress}>` : a.emailAddress)),
    cc: cc?.map(a => (a.displayName ? `${a.displayName} <${a.emailAddress}>` : a.emailAddress)),
    receivedAt: timestamp ? new Date(timestamp).toISOString() : undefined,
    bodyPreview: bodyHtml ? formatBodyPreview(bodyHtml) : undefined,
    hasAttachments: !!attachments?.length,
    hasRejectedAttachments
  };

  return (
    <Box
      onClick={onClick}
      sx={{
        marginX: '16px',
        marginTop: '16px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: isCollapsed ? '16px' : '0px',
        border: '1px solid #DDDDDD',
        borderRadius: isCollapsed ? '4px' : '4px 4px 0 0',
        padding: '12px',
        '&:hover': { cursor: 'pointer' }
      }}
    >
      <Box sx={{ width: '100%' }}>
        {isCollapsed ? <EmailHeaderPreview data={data} /> : <EmailHeaderExpanded data={data} />}
      </Box>
    </Box>
  );
};

export default EmailHeaderContainer;
